import Vue from 'vue'
import VueRouter from 'vue-router'
import { onAuthStateChanged } from 'firebase/auth'
import store from '../store'
import SignIn from '../components/auth/SignIn.vue'
import NavBar from '../components/NavBar.vue'
import Dashboard from '../components/dashboard/Dashboard.vue'
import Settings from '../components/settings/Settings.vue'
import TicketDetails from '../components/ticket/TicketDetails.vue'
import TicketDraft from '../components/ticket/TicketDraft.vue'
import TicketPrint from '../components/ticket/TicketPrint.vue'
import InventoryCart from '../components/inventory/Cart.vue'
import InventoryPayment from '../components/inventory/PaymentType.vue'
import Shift from '../components/shift/Shift.vue'
import Shifts from '../components/shift/Shifts.vue'
import ZXReport from '../components/shift/ZXReport.vue'
import SectionsReport from '../components/shift/SectionsReport.vue'
import OperatorsReport from '../components/shift/OperatorsReport.vue'
import FiscalReport from '../components/shift/FiscalReport.vue'
import CashRegister from '../components/settings/CashRegister.vue'
import AccessUsers from '../components/settings/AccessUsers.vue'
import Token from '../components/settings/Token.vue'
import Pincode from '../components/settings/Pincode.vue'
import Activation from '../components/settings/Activation.vue'
import Deactivation from '../components/settings/Deactivation.vue'
import Restore from '../components/settings/Restore.vue'
import Printer from '../components/settings/Printer.vue'
import Receipt from '../components/settings/Receipt.vue'
import Partners from '../components/partners/Partners.vue'
import KaspiQRSettings from '../components/partners/KaspiQR.vue'
import HalykPosSettings from '../components/partners/HalykPos.vue'
import HalykQRSettings from '../components/partners/HalykQR.vue'
import MoyuchetSettings from '../components/partners/Moyuchet.vue'
import Positions from '../components/settings/Positions.vue'
import AccessApi from '../components/settings/AccessApi.vue'
import Profile from '../components/settings/Profile.vue'
import LegalAndRegulatory from '../components/settings/LegalAndRegulatory.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/',
  },
  {
    path: '/signin',
    name: 'SignIn',
    meta: { requiresAuth: false },
    component: SignIn,
  },
  {
    path: '/',
    component: NavBar,
    alias: ['/main', '/list', '/miniapp'],
    children: [
      {
        path: '/',
        name: 'Dashboard',
        component: Dashboard,
      },
      {
        path: '/kkm',
        name: localStorage.getItem('rekassa.kz-ui-home-page') === null || localStorage.getItem('rekassa.kz-ui-home-page') === 'CALCULATOR' || localStorage.getItem('rekassa.kz-ui-home-page') === 'MAIN' ? 'MainCalculator' : 'MainPositions',
        component: () => {
          if (localStorage.getItem('rekassa.kz-ui-home-page') === null || localStorage.getItem('rekassa.kz-ui-home-page') === 'CALCULATOR' || localStorage.getItem('rekassa.kz-ui-home-page') === 'MAIN') {
            return import('../components/ticket/Calculator.vue')
          }
          return import('../components/ticket/parts/TicketDetailsMain.vue')
        },
      },
      {
        path: '/shifts/:cashRegisterId',
        name: 'Shifts',
        component: Shifts,
      },
      {
        path: '/settings',
        name: 'Settings',
        component: Settings,
      },
    ],
  },
  {
    path: '/partners',
    name: 'Partners',
    component: Partners,
  },
  {
    path: '/details',
    name: 'TicketDetails',
    component: TicketDetails,
  },
  {
    path: '/inventory/cart',
    name: 'InventoryCart',
    component: InventoryCart,
  },
  {
    path: '/inventory/payment',
    name: 'InventoryPayment',
    component: InventoryPayment,
  },
  {
    path: '/draft',
    name: 'TicketDraft',
    component: TicketDraft,
  },
  {
    path: '/print/:cashRegisterId/:ticketId',
    name: 'TicketPrint',
    component: TicketPrint,
    props: true,
  },
  {
    path: '/shifts/:cashRegisterId/:shiftNumber',
    name: 'Shift',
    component: Shift,
  },
  {
    path: '/shifts/:cashRegisterId/:shiftNumber/zxreport',
    name: 'ZXReport',
    component: ZXReport,
  },
  {
    path: '/shifts/:cashRegisterId/:shiftNumber/sections',
    name: 'SectionsReport',
    component: SectionsReport,
  },
  {
    path: '/shifts/:cashRegisterId/:shiftNumber/operators',
    name: 'OperatorsReport',
    component: OperatorsReport,
  },
  {
    path: '/kkm/settings',
    alias: '/kkm/fdo/payment-methods',
    name: 'CashRegister',
    component: CashRegister,
  },
  {
    path: '/receipt/settings',
    name: 'Receipt',
    component: Receipt,
  },
  {
    path: '/printer/settings',
    name: 'Printer',
    component: Printer,
  },
  {
    path: '/kkm/token',
    name: 'Token',
    component: Token,
  },
  {
    path: '/kkm/pincode',
    name: 'Pincode',
    component: Pincode,
  },
  {
    path: '/kkm/activation/:newCashRegisterId',
    name: 'Activation',
    component: Activation,
  },
  {
    path: '/kkm/deactivation',
    name: 'Deactivation',
    component: Deactivation,
  },
  {
    path: '/kkm/restore',
    name: 'Restore',
    component: Restore,
  },
  {
    path: '/kkm/access-users',
    name: 'AccessUsers',
    component: AccessUsers,
  },
  {
    path: '/kkm/access-api',
    name: 'AccessApi',
    component: AccessApi,
  },
  {
    path: '/kkm/kaspi/qr',
    name: 'KaspiQRSettings',
    component: KaspiQRSettings,
  },
  {
    path: '/kkm/halyk/pos',
    name: 'HalykPosSettings',
    component: HalykPosSettings,
  },
  {
    path: '/kkm/halyk/qr',
    name: 'HalykQRSettings',
    component: HalykQRSettings,
  },
  {
    path: '/kkm/moyuchet',
    name: 'MoyuchetSettings',
    component: MoyuchetSettings,
  },
  {
    path: '/kkm/positions',
    name: 'Positions',
    component: Positions,
  },
  {
    path: '/reports/fiscal',
    name: 'FiscalReport',
    component: FiscalReport,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
  },
  {
    path: '/kkm/legal-and-regulatory',
    name: 'LegalAndRegulatory',
    component: LegalAndRegulatory,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: import.meta.env.BASE_URL,
  routes,
})

// После деплоя старые чанки удаляются с сервера, и у пользователей с открытой вкладкой
// падает динамический импорт — перезагружаем страницу, чтобы подтянуть новую версию
const CHUNK_RELOAD_KEY = 'rekassa.kz-chunk-reload-at'

const isStaleChunkError = (error) => /dynamically imported module|Importing a module script failed|Unable to preload CSS/i.test(error && error.message)

const reloadOnStaleChunk = (path) => {
  const lastReloadAt = parseInt(sessionStorage.getItem(CHUNK_RELOAD_KEY) || '0', 10)
  if (Date.now() - lastReloadAt < 60000) {
    return false
  }
  sessionStorage.setItem(CHUNK_RELOAD_KEY, `${Date.now()}`)
  window.location.assign(path || window.location.href)
  return true
}

let pendingFullPath = null

router.beforeEach((to, from, next) => {
  pendingFullPath = to.fullPath
  next()
})

router.onError((error) => {
  if (isStaleChunkError(error)) {
    reloadOnStaleChunk(pendingFullPath)
  }
})

// Не гасим ошибку (preventDefault): иначе Vite резолвит импорт как undefined,
// и vue-router падает в isESModule, пока страница уходит в reload
window.addEventListener('vite:preloadError', () => {
  reloadOnStaleChunk(pendingFullPath)
})

const goSignin = (to, from, next) => {
  window.scrollTo(0, 0)
  next({ path: '/signin', query: { from: to.fullPath } })
}

const goNext = (next, path) => {
  window.scrollTo(0, 0)
  if (path) next(path)
  else next()
}

const getCurrentUser = () => new Promise((resolve) => {
  onAuthStateChanged(store.state.auth.firebaseAuth, (user) => {
    resolve(user)
  })
})

const saveUtmParamsToLocalStorage = (to) => {
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'page_title', 'page_path', 'referrer']
  utmParams.forEach(param => {
    if (to.query[param]) {
      localStorage.setItem(`rekassa.kz-marketing-${param}`, to.query[param])
    }
  })
}

router.beforeEach((to, from, next) => {
  saveUtmParamsToLocalStorage(to)

  const isAuthenticated = store.state.auth.user !== null
  if (to.meta.requiresAuth !== false && !isAuthenticated) {
    // Cordova
    if (window.cordova !== undefined) {
      if (!navigator.onLine) {
        store.dispatch('tools/setConnectionWarning', true)
      }

      window.FirebasePlugin.getCurrentUser((user) => {
        if (user) {
          store.dispatch('auth/setUser', user).then(() => {
            store.dispatch('cashRegisters/init', to).then(() => {
              goNext(next, to.path === '/' && (localStorage.getItem('rekassa.kz-ui-home-page') === 'CALCULATOR' || localStorage.getItem('rekassa.kz-ui-home-page') === 'POSITIONS') ? '/kkm' : null)
            }).catch(() => {
              // Стор не инициализирован (сеть/сервер) — не рендерим приложение с пустой кассой
              store.dispatch('tools/setConnectionWarning', true)
              next(false)
            })
          })
        } else {
          goSignin(to, from, next)
        }
      }, () => {
        goSignin(to, from, next)
      })

    // Web
    } else {
      getCurrentUser().then((user) => {
        if (user) {
          store.dispatch('auth/setUser', user).then(() => {
            store.dispatch('cashRegisters/init', to).then(() => {
              goNext(next, to.path === '/' && (localStorage.getItem('rekassa.kz-ui-home-page') === 'CALCULATOR' || localStorage.getItem('rekassa.kz-ui-home-page') === 'POSITIONS') ? '/kkm' : null)
            }).catch(() => {
              // Стор не инициализирован (сеть/сервер) — не рендерим приложение с пустой кассой
              store.dispatch('tools/setConnectionWarning', true)
              next(false)
            })
          })
        } else {
          goSignin(to, from, next)
        }
      }, () => {
        goSignin(to, from, next)
      })
    }
  } else {
    goNext(next)
  }
})

// Track screens
router.afterEach((to) => {
  store.dispatch('analytics/setScreenName', to.name)
})

export default router
